var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 20.775V22.5C41.7477 26.5433 40.4384 30.4775 38.0175 33.7159C35.5966 36.9543 32.1937 39.3234 28.3163 40.4698C24.4389 41.6162 20.2949 41.4786 16.5021 40.0773C12.7094 38.6761 9.47123 36.0864 7.27055 32.6945C5.06987 29.3026 4.02461 25.2901 4.29064 21.2556C4.55668 17.221 6.11976 13.3806 8.74677 10.307C11.3738 7.2334 14.924 5.09133 18.8679 4.20026C22.8117 3.3092 26.938 3.71687 30.6313 5.36249M41.75 7.49999L23 26.2687L17.375 20.6437",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/SuccessCheck.0ac34d8ecb518483a62c503609c6e8ca.svg";
export { ForwardRef as ReactComponent };